// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__36O-I","footer":"ChangeClinic_footer__2Y9wc"};